import { Card, CardContent } from "@/shared/ui/card";
import { Button } from "@/shared/ui/button";
import { CheckCircle } from "lucide-react";

interface CompleteStepProps {
  successCount: number;
  totalCount: number;
  onReset: () => void;
  onClose: () => void;
}

export function CompleteStep({ successCount, totalCount, onReset, onClose }: CompleteStepProps) {
  return (
    <Card className="text-center py-8">
      <CardContent>
        <CheckCircle className="h-12 w-12 mx-auto mb-4 text-green-600" />
        <h3 className="text-xl font-semibold mb-2">Import Complete!</h3>
        <p className="text-muted-foreground mb-6">
          Successfully imported {successCount} of {totalCount} properties
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={onReset} variant="outline">
            Import More
          </Button>
          <Button onClick={onClose}>Close</Button>
        </div>
      </CardContent>
    </Card>
  );
}
